import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@omni/components/components/Product/Feature/KeyFeatures/keyFeatures.container"
    ).then((module) => ({ default: module.KeyFeatures }))
);
